<ng-container *ngIf="records$ | async as records">
  <alert *ngIf="!records.length" type="danger">
    No se encuentran paneles asignados para el perfil actual
  </alert>

  <p-table
    [value]="records"
    styleClass="p-datatable-striped"
    selectionMode="single"
    [(selection)]="selectedPanel"
    dataKey="id"
    (onRowSelect)="onPanelSelect()"
  >
    <ng-template pTemplate="header">
      <tr>
        <th id="name-column">Nombre</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-record>
      <tr [pSelectableRow]="record">
        <td [innerHTML]="record.title | uppercase | markdown"></td>
      </tr>
    </ng-template>
  </p-table>
</ng-container>
